import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  AfFilter,
  AfFilterMenuActionsType,
} from 'data/afFilter/afFilter.types';
import './af-filter-action-menu.scss';

type Props = {
  selectedItem?: AfFilter;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onDelete: () => void;
}

const AfFilterMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegeToDelete,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="AfFilterMenu" className="filter-group-action-menu">
      {hasPrivilegeToDelete && (
        <Button
          className="filter-group-action-menu-button"
          data-testid={`${AfFilterMenuActionsType.Delete}-button`}
          text={t('afFilter.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('afFilter.deletePopup.title')}
        displayMessage={
          t('afFilter.deletePopup.message', { name: selectedItem.fgId })
        }
        actionText={t('afFilter.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default AfFilterMenu;
